import React from 'react'
import { Navigate } from 'react-router-dom'
import { ROLES } from '../../constants/roles'

const getStoredRole = () => (typeof window !== 'undefined' ? localStorage.getItem('role') ?? '' : '')

interface RoleGuardProps {
  /** Roles permitted to view the children. */
  allow: ROLES[]
  /** Where to redirect when the current role is not permitted. Defaults to the user home. */
  redirect?: string
  children: React.ReactNode
}

/**
 * Client-side role guard for routes. This is a UX convenience only — the
 * backend enforces permissions server-side.
 *
 * Reads the role from localStorage on purpose: when an admin previews the app
 * as a regular user (see the role switch in TopBar), localStorage 'role' is set
 * to 'user' and restored to the real role on switch-back. Every role switch
 * triggers a full page reload, so this value is always current at render time.
 */
const RoleGuard = ({ allow, redirect = '/user/home', children }: RoleGuardProps) => {
  const role = getStoredRole()
  return (allow as string[]).includes(role) ? <>{children}</> : <Navigate to={redirect} replace />
}

export default RoleGuard
